<template>
  <nav class="activity__filter-group">
    <ActivityFilter
      :filter="filter"
      :max="filters.length - 1"
      :active="activeFilterIndex"
      :last-active="lastActiveFilterIndex"
      v-for="filter in filters"
      :key="filter.id"
      @update-active-filter="updateActiveFilterIndex"
    />
  </nav>
</template>

<script>
import { ActivityFilter } from '@/components/navigation'

export default {
  name: 'ActivityFilters',
  components: { ActivityFilter },
  data() {
    return {
      activeFilterIndex: 0,
      lastActiveFilterIndex: 0,
    }
  },
  computed: {
    filters() {
      return [{ id: 0 }].concat(this.$store.state.categories.items).map((category, index) => {
        return { ...category, index: index }
      })
    },
  },
  methods: {
    updateActiveFilterIndex(newIndex) {
      this.lastActiveFilterIndex = this.activeFilterIndex
      this.activeFilterIndex = newIndex
    },
  },
}
</script>
